import { CheckTextSelect } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const headList: any[] = [
  {
    headTitle: "決裁日",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "退職者名",
    keyword: "retireeName",
    type: "text",
    showLine: false,
  },
  {
    title: "請求者氏名（ｶﾅ）",
    keyword: "demanderNameKana",
    type: "text",
  },
  {
    title: "請求者氏名（全角漢字）",
    keyword: "demanderName",
    type: "text",
  },
  {
    title: "請求者生年月日",
    keyword: "demanderBirth",
    type: "text",
  },
  {
    title: "請求者住所（郵便番号）",
    keyword: "demanderZipcode",
    type: "text",
  },
  {
    title: "請求者住所",
    keyword: "locationGroup",
    type: "text",
  },
  {
    title: "請求者連絡先",
    keyword: "tel",
    type: "text",
  },
  {
    title: "請求者メールアドレス",
    keyword: "demanderEmail",
    type: "text",
  },
  {
    title: "代行者連絡先メールアドレス",
    keyword: "agentEmail",
    type: "text",
  },
  {
    title: "金融機関コード",
    keyword: "bankCd",
    type: "text",
  },
  {
    title: "金融機関名",
    keyword: "bankName",
    type: "text",
  },
  {
    title: "支店コード",
    keyword: "branchCd",
    type: "text",
  },
  {
    title: "支店名",
    keyword: "branchName",
    type: "text",
  },
  {
    title: "預金種目",
    keyword: "depositType",
    type: "text",
  },
  {
    title: "口座番号",
    keyword: "accountNo",
    type: "text",
  },
  {
    title: "口座名義人名(半角ｶﾀｶﾅ)",
    keyword: "accountNameKana",
    type: "text",
  },
  {
    title: "「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathOrAutopsyReport",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title:
      "職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "yesLivelihoodInvestForm",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title:
      "職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "noLivelihoodInvestForm",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "内縁関係についての「生計維持に関する調査書」（様式１１号）",
    keyword: "marriageReport",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」",
    keyword: "certifiedCertificateResidence",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },

  {
    title: "その他、事実上の配偶者であることを証明する書類",
    keyword: "claimantPartnerBook",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "確認する書類の選択",
    keyword: "identifyDocsKind",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CheckTextSelect),
    disabled: true,
  },
  {
    title: "死亡した退職者の個人番号を確認する書類",
    keyword: "deceasedRetireeNumCheckDoc",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDocs1",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDocs2",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類（表面）",
    keyword: "identityDocHead",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類（裏面）",
    keyword: "identityDocTail",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "個人番号を確認する書類",
    keyword: "numberCheckDoc",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "振込先口座が確認できる書類",
    keyword: "payAccountCheckDoc",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
];

const schema: any = {
  memo: {
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
  },
};

const fileDisplayMap: { [key: string]: string[] } = {
  identityDocs1: [
    CheckTextSelect["個人番号カード（１２桁の番号のある面）"],
    CheckTextSelect["個人番号が記載された住民票＋写真無し身分証明２点"],
    CheckTextSelect["通知カード＋写真無し身分証明２点"],
  ],
  identityDocs2: [
    CheckTextSelect["個人番号が記載された住民票＋写真無し身分証明２点"],
    CheckTextSelect["通知カード＋写真無し身分証明２点"],
  ],
  identityDocHead: [
    CheckTextSelect["個人番号が記載された住民票＋写真付き身分証明１点"],
    CheckTextSelect["通知カード＋写真付き身分証明１点"],
  ],
  identityDocTail: [
    CheckTextSelect["個人番号が記載された住民票＋写真付き身分証明１点"],
    CheckTextSelect["通知カード＋写真付き身分証明１点"],
  ],
};

export { fakeTableList, schema, headList, fileDisplayMap };
